import { goto } from '$app/navigation';
import { getAPIUrl } from '$lib/api';
import { Capacitor } from '@capacitor/core';

export function isMobileAPISetup() {
	return getAPIUrl() !== null;
}

export function wrappedGoto(url: string) {
	if (!isMobileAPISetup()) {
		return;
	}
	goto(url);
}

export function runIfNative(fn: () => void) {
	if (Capacitor.isNativePlatform()) {
		return fn();
	}
}
export function runIfWeb(fn: () => void) {
	if (!Capacitor.isNativePlatform()) {
		return fn();
	}
}
